import { CSSObject } from '@chakra-ui/react';
import overviewBannerDesktop from '@/assets/oldgill/images/backgrounds/overviewBannerDesktop.png';
import overviewBannerMobile from '@/assets/oldgill/images/backgrounds/overviewBannerMobile.png';
import { BannerSchema } from '@/views/account/Overview/components/Banner/styles/Banner.styles';

export const FlexAccountDetails: CSSObject = {
  flexDir: ['column', null, 'row'],
  w: 'full',
  gap: ['1', null, '2'],
  alignItems: ['unset', null, 'center'],
};

export const FlexAccountName: CSSObject = {
  fontSize: 'xl',
  color: 'white',
  fontWeight: 'semibold',
  filter: 'drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.5))',
};

export const FlexBannerContainer: CSSObject = {
  p: '2.5',
  bg: [`url(${overviewBannerMobile})`, null, `url(${overviewBannerDesktop})`],
  '&&': {
    backgroundSize: ['cover', '100% auto', 'auto 100%'],
    backgroundPosition: ['center top', 'left'],
    backgroundRepeat: 'no-repeat',
  },
  borderRadius: 'base',
  border: '2px solid',
  borderColor: 'beta.400',
  gap: ['2', null, 'unset'],
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35)',
  minH: 'auto',
};

export const FlexBannerBalanceInner: CSSObject = {
  flex: ['1', null, '0 1 auto'],
};

export const FlexLabel: CSSObject = {
  w: ['full', null, 'unset'],
  flex: '1',
};

export const bannerStyles: BannerSchema = {
  buttonDeposit: {
    variant: 'secondary',
    h: 8,
    borderRadius: 'lg',
  },
};

export const FlexBalanceBetInfo: CSSObject = {
  px: '3',
  py: '3',
  bg: 'transparent',
  color: 'white',
  border: '2px',
  borderColor: 'white',
  borderRadius: 'md',
  boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  fontSize: '2xs',
  h: '8',
  fontWeight: 'extrabold',
  textTransform: 'uppercase',
  alignItems: 'center',
  justifyContent: 'center',
  flex: ['1', null, 'unset'],
};

export const FlexAccountBalances: CSSObject = {
  flexDir: 'row',
  gap: ['8', null, '6'],
  justifyContent: ['space-between', null, 'unset'],
  filter: 'drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.5))',
};

export const TextButton: CSSObject = {
  alignSelf: 'center',
  fontSize: 'xs',
  fontWeight: 'normal',
};

export const TextAccountBalanceLabel: CSSObject = {
  textTransform: 'uppercase',
  fontSize: 'xs',
  fontWeight: 'bold',
  letterSpacing: 'wider',
  color: 'white',
};

export const TextAccountBalanceBaseUnit = (): CSSObject => ({
  textTransform: 'uppercase',
  fontSize: 'xl',
  fontWeight: 'extrabold',
  color: 'beta.400',
});

export const TextAccountBalanceSubUnit = (): CSSObject => ({
  textTransform: 'uppercase',
  fontSize: 'sm',
  fontWeight: 'extrabold',
  color: 'beta.400',
  opacity: '0.7',
});

export const TextAccountBalanceCurrencySymbol = (): CSSObject => ({
  mt: '0.5',
  mr: '0.5',
  alignSelf: 'flex-start',
  textTransform: 'uppercase',
  fontSize: 'xs',
  fontWeight: 'bold',
  color: 'beta.300',
});

export const FlexButtonContainer: CSSObject = {
  fontSize: '2xs',
  gap: '2',
  flexDir: ['column', null, 'row'],
  filter: 'drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.3))',
  alignItems: 'center',
};
